export const YEAR = 'years';
export const MONTH  = 'months';
export const MAX_YEARS = 5;
export const MAX_MONTHS = 12;

export  const timeSpanTypeOpt = [
  { label: 'No of Years', value: YEAR, maxCount: MAX_YEARS, tKey: 'no_of_years' },
  { label: 'No of Months', value: MONTH, maxCount: MAX_MONTHS, tKey: 'no_of_months' },
];

export  const REVET_ONE = 'one_off';
export  const REVET_FREQ = 'frequency';

export  const revettingTypeOpt = [
  { label: 'One Off', value: REVET_ONE, tKey: 'one_off' },
  { label: 'Frequency', value: REVET_FREQ, tKey: 'frequency' },
];
